export const BASE_URI = '/home';
export const BASE_URI_LP = '/lp';
export const ERROR_URI = '/error';

// *** Auth ***
export const SIGNIN = `${BASE_URI}/signin`;
export const SIGNOUT = `${BASE_URI}/signout`;
export const ONBOARDING = `${BASE_URI}/onboarding`;
export const REGISTER = `${BASE_URI}/register`;
export const FORGOT_PASSWORD = `${BASE_URI}/forgot-password`;

// *** Taxes ***
export const TAXES = `${BASE_URI}/taxes`;

// *** NerdWallet Plus ***
export const NERDWALLET_PLUS = `${BASE_URI}/nerdwallet-plus`; // This route is also used in mobile-creditcards
export const NERDWALLET_PLUS_INSURANCE_ONBOARDING = `${BASE_URI}/nerdwallet-plus/onboarding-insurance`;
export const NERDWALLET_PLUS_MANAGE_SUBSCRIPTION = `${BASE_URI}/subscription/settings`;
export const NERDWALLET_PLUS_CHECKOUT = `${NERDWALLET_PLUS}/checkout`;
export const NERDWALLET_PLUS_ACTIVITY_IN_PROGRESS = `${NERDWALLET_PLUS}/activity/in-progress`;
export const NERDWALLET_PLUS_ACTIVITY_EARNED = `${NERDWALLET_PLUS}/activity/earned`;
export const NERDWALLET_PLUS_ACTIVITY_REDEEMED = `${NERDWALLET_PLUS}/activity/redeemed`;
export const NERDWALLET_PLUS_INVESTMENT_ACCOUNTS = `${NERDWALLET_PLUS}/investment-accounts`;
export const NERDWALLET_PLUS_TREASURY_EMBED = `/my-nerdwallet-embed/native-app/home/nerdwallet-plus/treasury`;
export const LP_NERDWALLET_PLUS_TREASURY = `/lp/treasury-account`;
export const LP_NERDWALLET_PLUS_AUTOMATED_INVESTING = `/lp/automated-investing`;
export const NERDWALLET_PLUS_ONBOARDING = `${NERDWALLET_PLUS}/onboarding`;

// *** NerdWallet Plus Landing Pages ***
export const NERDWALLET_PLUS_LANDING_PAGE = `${BASE_URI_LP}/nerdwallet-plus`;
export const NERDWALLET_PLUS_MAIN_LANDING_PAGE = `${BASE_URI_LP}/nerdwallet-plus-main`;
export const NERDWALLET_PLUS_LANDING_PAGE_FAQ = `${BASE_URI_LP}/nerdwallet-plus/faq`;

// *** NerdWallet Plus Rewards Dashboard ***
export const NERDWALLET_PLUS_REWARDS = `${NERDWALLET_PLUS}/rewards`;
export const NERDWALLET_PLUS_REWARDS_REDEEM = `${NERDWALLET_PLUS_REWARDS}/redeem`;
export const NERDWALLET_PLUS_REWARDS_CASH = `${NERDWALLET_PLUS_REWARDS}/cash`;
export const NERDWALLET_PLUS_WAYS_TO_EARN = `${NERDWALLET_PLUS}/ways-to-earn`;
export const NERDWALLET_PLUS_BANKING_ONBOARDING = `${BASE_URI}/nerdwallet-plus/onboarding-banking`;
export const NERDWALLET_PLUS_CC_ONBOARDING = `${BASE_URI}/nerdwallet-plus/onboarding-cc`;
export const NERDWALLET_PLUS_INSURANCE_DASHBOARD = `${BASE_URI}/nerdwallet-plus/insurance`; // This route exists in my-nerdwallet-next
export const NERDWALLET_PLUS_SUBSCRIPTION_SUCCESS = `${BASE_URI}/subscription/success`;

/*** Investment Accounts (Free) */
export const INVESTMENT_ACCOUNTS = `${BASE_URI}/investment-accounts`;
export const INVESTMENT_ACCOUNTS_EMBED = `/my-nerdwallet-embed/native-app/home/investment-accounts`;

/*** Insurance Management (Free) ***/
export const INSURANCE = `${BASE_URI}/insurance`;
export const INSURANCE_POLICY = (policyId: string) =>
  `${INSURANCE}/policies/${policyId}`;
export const INSURANCE_DOCUMENT = (documentId: string) =>
  `${INSURANCE}/documents/${documentId}`;
export const INSURANCE_RATE_REPORT = (policyId: string) =>
  `${INSURANCE}/report/${policyId}`;

/*** Insurance Management (NW+) ***/
export const NERDWALLET_PLUS_INSURANCE = `${NERDWALLET_PLUS}/insurance`;
export const NERDWALLET_PLUS_INSURANCE_POLICY = (policyId: string) =>
  `${NERDWALLET_PLUS}/insurance/policies/${policyId}`;
export const NERDWALLET_PLUS_INSURANCE_RATE_REPORT = (policyId: string) =>
  `${NERDWALLET_PLUS}/insurance/report/${policyId}`;
export const NERDWALLET_PLUS_INSURANCE_REVIEW_INFO = (policyId: string) =>
  `${NERDWALLET_PLUS_INSURANCE}/review-info/${policyId}`;
export const NERDWALLET_PLUS_INSURANCE_DOCUMENT = (documentId: string) =>
  `${NERDWALLET_PLUS_INSURANCE}/documents/${documentId}`;
export const NERDWALLET_PLUS_INSURANCE_INTRO = `${NERDWALLET_PLUS}/intro-insurance`;

// *** Dashboard - Miscellaneous ***
export const DASHBOARD = `${BASE_URI}/dashboard`;
export const DASHBOARD_ACCOUNT_DETAILS = `${DASHBOARD}/account/:id`;
export const DASHBOARD_ACCOUNT_DETAILS_DETAILS = `${DASHBOARD_ACCOUNT_DETAILS}/details`;
export const DASHBOARD_ACCOUNT_ASSET_DETAILS = `${DASHBOARD}/account/asset/:id`;
export const DASHBOARD_HOME = `${DASHBOARD}/home`;
export const DASHBOARD_RECENTLY_VIEWED = `${DASHBOARD}/recently-viewed`;
export const DASHBOARD_SAVED_ARTICLES = `${DASHBOARD}/saved-articles`;
export const DASHBOARD_NERD_UP = `${DASHBOARD}/nerd-up`;
export const DASHBOARD_CREDIT_SCORE = `${DASHBOARD}/credit-score`;
export const DASHBOARD_CREDIT_SCORE_AGE_AND_MIX = `${DASHBOARD_CREDIT_SCORE}/age-and-mix`;
export const DASHBOARD_CREDIT_SCORE_BALANCES = `${DASHBOARD_CREDIT_SCORE}/balances`;
export const DASHBOARD_CREDIT_SCORE_GOAL_AND_TIPS = `${DASHBOARD_CREDIT_SCORE}/goal-and-tips`;
export const DASHBOARD_CREDIT_SCORE_FULL_REPORT = `${DASHBOARD_CREDIT_SCORE}/credit-report`;
export const DASHBOARD_CREDIT_SCORE_INQUIRIES = `${DASHBOARD_CREDIT_SCORE}/inquiries`;
export const DASHBOARD_CREDIT_SCORE_PAYMENTS = `${DASHBOARD_CREDIT_SCORE}/payments`;
export const DASHBOARD_CREDIT_SCORE_UTILIZATION = `${DASHBOARD_CREDIT_SCORE}/utilization`;
export const DASHBOARD_NERD_UP_HOME = `${DASHBOARD}/nerd-up?subsection=home`;
export const DASHBOARD_NET_WORTH = `${DASHBOARD}/net-worth`;
export const DASHBOARD_CASH_FLOW = `${DASHBOARD}/cash-flow`;
export const DASHBOARD_CASH_FLOW_BUDGET = `${DASHBOARD_CASH_FLOW}/budget`;
export const DASHBOARD_TRANSACTIONS = `${DASHBOARD}/transactions`;

// *** Dashboard - Spending ***
export const DASHBOARD_SPENDING = `${BASE_URI}/dashboard/spending`;
export const SPENDING_NET_SAVINGS = `${DASHBOARD_SPENDING}/net-savings`;
export const SPENDING_TOP_SPENDING = `${DASHBOARD_SPENDING}/top-spending`;
export const SPENDING_TOP_CATEGORIES = `${SPENDING_TOP_SPENDING}/categories`;
export const SPENDING_TOP_MERCHANTS = `${SPENDING_TOP_SPENDING}/places`;

// *** Settings ***
export const SETTINGS = `${DASHBOARD}/settings`;
export const SETTINGS_ACCOUNTS = `${SETTINGS}/accounts`;
export const SETTINGS_NOTIFICATIONS = `${SETTINGS}/notifications`;
export const SETTINGS_INFO = `${SETTINGS}/info`;
export const SETTINGS_SECURITY = `${SETTINGS}/security`;
export const SETTINGS_FOLLOWING = `${SETTINGS}/following`;
export const SETTINGS_SUBSCRIPTION = `${SETTINGS}/subscription`;

export const SETTINGS_SUBSCRIPTION_EDIT_MAILING_ADDRESS = `${SETTINGS_SUBSCRIPTION}/mailing-address`;
export const SETTINGS_SUBSCRIPTION_EDIT_BILLING_DETAILS = `${SETTINGS_SUBSCRIPTION}/billing-details`;
export const SETTINGS_SUBSCRIPTION_VIEW_BILLING_HISTORY = `${SETTINGS_SUBSCRIPTION}/billing-history`;
